export default "__VITE_ASSET__d442e8c5__"